export default {
  name: 'marking--paymentType',
};